export const getModalIsOpen = ({ state }) => state.modalReducer.isModalOpen;
export const getCallCenterModalOpen = ({ state }) =>
  state.modalReducer.isCallCenterOpen;
export const getCallCenterData = ({state}) => state.modalReducer.data;;
